<div class="input-list">
  @for (control of rows.controls; track control; let index = $index) {
    <div class="input-list__row">
      <input-v2
        class="input-list__input"
        [formControl]="control"
        [type]="type()"
        [placeholder]="placeholder() | translate"
        [maxLength]="maxLength()"
      />
      @if (rows.length > 1 || control.value) {
        <button
          type="button"
          class="input-list__remove"
          [attr.aria-label]="'InputList.remove' | translate"
          [title]="'InputList.remove' | translate"
          [disabled]="disabled()"
          (click)="remove(index)"
        >
          <span class="material-icons" aria-hidden="true">close</span>
        </button>
      }
    </div>
  }

  <button type="button" class="input-list__add" [disabled]="disabled()" (click)="add()">
    {{ addLabel() | translate }}
  </button>
</div>
